import { createSlice } from '@reduxjs/toolkit';
import { documentsList, fetchDocumentById, fetchDocumentsByIds, fetchBlankDocument } from '../actions/documentsActions';
import { isPdf } from '../../utils/documentFiles';

const initialState = {
  documentData: [], // Список всех документов
  documentsDatas: [],
  currentDocument: null, // Текущий выбранный документ
  blankDocument: null, // Системный документ чистого листа A4 (услуга BlankSheet)
  loading: false,
  error: null,
};

// Не-PDF (офисные форматы и изображения) конвертируются бэкендом — см. utils/documentFiles.js
const isConvertibleDoc = (fileName) => !isPdf(fileName);

const documentsSlice = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    setCurrentDocument: (state, action) => {
      const doc = action.payload;
      if (doc && doc.id) {
        state.currentDocument = {
          ...doc,
          file_path: isConvertibleDoc(doc.file_name)
            ? `${process.env.REACT_APP_BASEURL}/api/v1/documents/convert/${doc.id}`
            : doc.file_path, // Оставляем оригинальный file_path для PDF
        };
      } else {
        state.currentDocument = null;
      }
    },
  },
  extraReducers: builder => {
    builder
      // Обработка documentsList
      .addCase(documentsList.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(documentsList.fulfilled, (state, action) => {
        state.loading = false;
        state.documentsDatas = action.payload.length ? action.payload : [];
      })
      .addCase(documentsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Обработка fetchDocumentById
      .addCase(fetchDocumentById.pending, state => {
        state.loading = true;
        state.error = null;
        state.currentDocument = null; // Сбрасываем currentDocument перед загрузкой
      })
      .addCase(fetchDocumentById.fulfilled, (state, action) => {
        state.loading = false;
        const doc = action.payload;
        state.currentDocument = {
          ...doc,
          file_path: isConvertibleDoc(doc.file_name)
            ? `${process.env.REACT_APP_BASEURL}/api/v1/documents/convert/${doc.id}`
            : doc.file_path, // Оставляем оригинальный file_path для PDF
        };
        if (!state.documentData.some(d => d.id === doc.id)) {
          state.documentData.push({
            ...doc,
            file_path: isConvertibleDoc(doc.file_name)
              ? `${process.env.REACT_APP_BASEURL}/api/v1/documents/convert/${doc.id}`
              : doc.file_path,
          });
        }
      })
      .addCase(fetchDocumentById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Обработка fetchDocumentsByIds
      .addCase(fetchDocumentsByIds.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDocumentsByIds.fulfilled, (state, action) => {
        state.loading = false;
        const newDocs = action.payload.filter(
          newDoc => !state.documentData.some(doc => doc.id === newDoc.id)
        ).map(doc => ({
          ...doc,
          file_path: isConvertibleDoc(doc.file_name)
            ? `${process.env.REACT_APP_BASEURL}/api/v1/documents/convert/${doc.id}`
            : doc.file_path,
        }));
        state.documentData = [...state.documentData, ...newDocs];
        if (!state.currentDocument && newDocs.length > 0) {
          state.currentDocument = newDocs[0];
        }
      })
      .addCase(fetchDocumentsByIds.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Обработка fetchBlankDocument
      .addCase(fetchBlankDocument.fulfilled, (state, action) => {
        state.blankDocument = action.payload;
      })
      .addCase(fetchBlankDocument.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { setCurrentDocument } = documentsSlice.actions;
export default documentsSlice.reducer;